var React = require('react');

var createReactClass = require('create-react-class');
module.exports = createReactClass({
  render : function () {
    return (
      <label className="radio">
        <input type="radio"
          name={this.props.name}
          value={this.props.value}
          defaultChecked={this.props.checked}
          onChange={this.props.onChange} /> {this.props.label}
      </label>
    );
  }
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/radio_input.jsx